import { Component, EventEmitter, Input, Output } from '@angular/core'
import { removeToolTip } from 'src/app/_helpers/Utils'

@Component({
	selector: 'app-header-report',
	templateUrl: './header-report.component.html'
})
export class HeaderReportComponent {
		@Input() public typeReport: 'Inventário' | 'Plantio' | 'Avaliação' | 'Manejo'
	@Input() public enableActions: boolean = false
	@Input() public enableAssign: boolean = false
	@Input() public disabledAssign: boolean = true
	@Input() public enableEdit: boolean = false
	@Input() public enableSave: boolean = false
	@Input() public showTitleReport: boolean = true
	@Input() public isNotification: boolean = false

	@Output() public print = new EventEmitter()
	@Output() public edit = new EventEmitter()
	@Output() public assign = new EventEmitter()
	@Output() public save = new EventEmitter()

	public showActions: boolean = false

	public switchShowActions() {
		this.showActions = !this.showActions
		removeToolTip()
	}

	public printReport() {
		this.print.emit()
		this.showActions = false
	}

	public editReport() {
		this.edit.emit()
		this.showActions = false
	}

	public assignReport() {
		if (!this.disabledAssign) {
			this.assign.emit()
		}
		this.showActions = false
	}

	public saveReport() {
		this.save.emit()
		this.showActions = false
	}
}
